import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import History from "@/pages/History";
import Scanner from "@/pages/Scanner";
import Login from "@/pages/Login";
import { getToken } from "@/lib/api";

const RequireAuth = ({ children }) => {
  if (!getToken()) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/scanner"
            element={
              <RequireAuth>
                <Scanner />
              </RequireAuth>
            }
          />
          <Route
            path="/history"
            element={
              <RequireAuth>
                <History />
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth>
                <Settings />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            border: "1px solid #222",
            color: "#fff",
            fontFamily: "JetBrains Mono",
          },
        }}
      />
    </div>
  );
}

export default App;
